import { addBreadcrumb, appsignal, decorateSpan, type FrontendErrorContext } from '../appsignal';

export const sendError = (error: Error, context: FrontendErrorContext = {}) => {
  if (context.breadcrumb) {
    addBreadcrumb(context.breadcrumb);
  }

  appsignal?.sendError(error, span => decorateSpan(span, context));
};
